import { FC, ReactNode, useState } from 'react'
import { StyleImage } from './style'
import DefaultUser from './default-user.png'
import Default from './no-image.jpeg'
import DefaultDoctor from './default-doctor.png'
import DefaultUserBanner from './default-user-banner.png'
interface ImageProps {
  src: string
  alt?: string
  width?: number
  height?: number
  fit?: 'cover' | 'contain'
  fallbackType?: 'empty' | 'user' | 'doctor' | 'userBanner'
  styleImage?: string | ReactNode
  onClick?: () => void
}
const Image: FC<ImageProps> = ({
  fallbackType = 'empty',
  src,
  ...restprops
}) => {
  const [imgSrc, setImgSrc] = useState(src)
  const handleError = () => {
    setImgSrc(
      fallbackType === 'user'
        ? DefaultUser
        : fallbackType == 'doctor'
          ? DefaultDoctor
          : fallbackType == 'userBanner'
            ? DefaultUserBanner
            : Default,
    )
  }
  return <StyleImage {...restprops} src={imgSrc} onError={handleError} />
}

export default Image
